import { translation, TranslationsContext } from '../../../../Translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import clsx from 'clsx';
import Person from '../../../../components/Person';
import Dropdown from '../../../Dropdown';

const NavUserImpl: React.FC = () => (
  <TranslationsContext.Consumer>
    {(ts) => (
      <div
        className={clsx(
          'cursor-pointer',
          'translate-z-0 translate-x-0 translate-y-0 ',
          'group  rounded-full group-hover:shadow-sm',
        )}
      >
        <Dropdown
          header={
            <button
              title={translation('Account Navigation Dropdown Menu')(ts)}
              className={clsx(
                'rounded-full group-focus-visible:ring-offset-sky-50',
                'group-focus-visible:ring-offset-2',
              )}
              role="button"
              aria-label={translation('Account Navigation')(ts)}
              tabIndex={-1}
              aria-haspopup="listbox"
            >
              <Person />
              <span
                className={clsx(
                  'text-xs text-neutral-100',
                  'scale-105 opacity-70 group-hover:scale-110 group-hover:opacity-100',
                  'group-focus:text-white',
                )}
              >
                <i className="fa fas fa-caret-down"></i>
              </span>
            </button>
          }
          aria-labelledby={'Account Navigation'}
        />
      </div>
    )}
  </TranslationsContext.Consumer>
);

export default observer(NavUserImpl);
